import React, { useState } from 'react';
const faqItems = [{
  question: '⚽ ¿Funciona aunque mi hijo sea muy tímido o se bloquee fácilmente?',
  answer: 'Sí. Está pensado justamente para chicos que sienten presión, dudas o miedo a equivocarse. Cuando cambia la mentalidad, cambia la forma en la que se paran en la cancha.'
}, {
  question: '⚽ ¿En cuánto tiempo voy a notar cambios reales?',
  answer: 'Si aplicás el método, vas a empezar a ver cambios en pocas semanas. En tan solo 15 días muchos padres ya notan más seguridad y menos miedo a equivocarse. No es magia. Es entrenamiento mental aplicado.'
}, {
  question: '⚽ ¿Mi hijo tiene que leer el programa o lo puedo guiar yo?',
  answer: 'Podés hacerlo de las dos formas. La guía está pensada para que vos lo acompañes paso a paso. Ahí es donde se potencia el cambio.'
}, {
  question: '⚽ ¿Esto reemplaza el entrenamiento físico?',
  answer: 'No. Lo potencia. La diferencia muchas veces no está en la técnica… sino en la cabeza.'
}, {
  question: '⚽ ¿Y si no veo mejoras?',
  answer: 'Tenés garantía. Podés probarlo sin riesgo.'
}, {
  question: '⚽ ¿Necesito materiales especiales?',
  answer: 'No. Solo compromiso y constancia. Todo lo necesario está incluido.'
}];
export function FaqSection() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const toggle = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return <section className="w-full" style={{
    padding: '50px 16px',
    background: '#f5f5f5'
  }} data-id="element-61">
      {/* Title */}
      <div style={{
      textAlign: 'center'
    }} data-id="element-62">
        <h2 style={{
        fontSize: '22px',
        fontWeight: 800,
        color: '#111'
      }} data-id="element-63">
          ⚽ Preguntas Frecuentes
        </h2>
        <div style={{
        width: '60px',
        height: '3px',
        background: '#22c55e',
        margin: '10px auto 30px auto',
        borderRadius: '2px'
      }} data-id="element-64" />
      </div>

      {/* FAQ Items */}
      <div style={{
      maxWidth: '600px',
      margin: '0 auto'
    }} data-id="element-65">
        {faqItems.map((item, index) => <div key={index} style={{
        background: '#ffffff',
        borderRadius: '12px',
        marginBottom: '10px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
        overflow: 'hidden'
      }} data-id="element-66">
            <div onClick={() => toggle(index)} style={{
          padding: '14px 16px',
          fontSize: '14px',
          fontWeight: 600,
          color: '#111',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: 'pointer'
        }} data-id="element-67">
              <span data-id="element-68">{item.question}</span>
              <span style={{
            color: '#22c55e',
            fontSize: '18px',
            fontWeight: 700,
            transition: 'transform 0.3s ease',
            transform: activeIndex === index ? 'rotate(45deg)' : 'rotate(0deg)'
          }} data-id="element-69">
                +
              </span>
            </div>
            <div style={{
          maxHeight: activeIndex === index ? '300px' : '0',
          overflow: 'hidden',
          transition: 'max-height 0.3s ease',
          padding: activeIndex === index ? '0 16px 14px 16px' : '0 16px',
          fontSize: '13px',
          color: '#4b5563',
          lineHeight: 1.6
        }} data-id="element-70">
              {item.answer}
            </div>
          </div>)}
      </div>

      {/* CTA Button */}
      <a href="https://infoliar.com/cart/56736084721996:1" className="adn-pulse-btn" style={{
      margin: '40px auto 20px auto',
      display: 'block',
      width: '100%',
      maxWidth: '500px',
      background: 'linear-gradient(90deg, #16a34a, #22c55e)',
      color: '#fff',
      fontWeight: 800,
      padding: '16px',
      border: 'none',
      borderRadius: '40px',
      fontSize: '15px',
      boxShadow: '0 8px 20px rgba(34,197,94,0.35)',
      cursor: 'pointer',
      textDecoration: 'none',
      textAlign: 'center',
      boxSizing: 'border-box'
    }} aria-label="Descargar el método ahora" data-id="element-71">
        DESCARGAR EL MÉTODO AHORA
      </a>

      {/* Payment Image */}
      <img src="https://res.cloudinary.com/dd0wtuekk/image/upload/v1771287819/image_41_ktiee7.jpg" alt="Métodos de pago seguros" style={{
      display: 'block',
      margin: '0 auto',
      width: '100%',
      maxWidth: '350px',
      borderRadius: '10px'
    }} data-id="element-72" />
    </section>;
}